exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".proportion-question[data-v-2bb1122f]{position:relative}.proportion-box[data-v-2bb1122f]{padding:0 14px}.flex[data-v-2bb1122f]{display:-ms-flexbox;display:flex}.flex .flex-1[data-v-2bb1122f]{-ms-flex:1;flex:1}.flex .count[data-v-2bb1122f]{width:40px;text-align:right;padding-top:7px}.tips[data-v-2bb1122f]{margin-bottom:8px}.text-info[data-v-2bb1122f]{color:#999}.sub-title[data-v-2bb1122f]{margin-bottom:5px}", ""]);

// exports
